import L from "../locales";
const l = L.orderStatus;
// 认证状态
export const orderStatus = [
  l.os_in_review, // 审核中0
  l.os_the_loan_reject, // 拒绝1
  l.os_the_loan_cancel, // 取消2
  l.os_in_the_lending, // 放款中3
  l.os_the_loan_fail, // 放款失败4
  l.os_the_loan_settle, // 完成5
  l.os_for_reimbursement, // 待还款6
  l.os_the_loan_overdue, // 逾期7
  l.os_the_loan_timeout_refuse, // 超时拒绝8
  l.os_the_loan_return, // 退回9
  l.os_the_loan_withdraw, // 待提现10
];

export const orderList = [
  {
    amount2Account: "5,500.00",
    app_time: "20/06/2022",
    application_id: "5020220620000006052",
    apply_time: 1655740030000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 2,
    borrow_time: "2022-06-20",
    borrow_time_kim: "2022-06-20 22:51:26",
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    deposit_time: "22/06/2022",
    duration: "7",
    email: "gkfhj@gmail.com",
    fale_fee: "200.00",
    fee: 4500,
    has_loan_app: true,
    interest: 700,
    interestRate: 1,
    loan_status: 7,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 2500,
    pay_time: "20/06/2022",
    paymentAmount: "10,700.00",
    penalty: "3,230.00",
    penalty_days: 17,
    principal: "10,000",
    reApplyFace: false,
    reach_amount: "500.00",
    reach_time: 1655658000000,
    real_reach_time: "2022-06-20 00:00:00",
    remainAmount: "13,530.00",
    repaymentAmount: "100.00",
    repayment_day: "0",
    risk: 1000,
    rollover_fee: "8,530",
    secAppTime: null,
    service: 1000,
  },
  {
    amount2Account: "5,500.00",
    app_time: "06/06/2022",
    application_id: "5020220620000006049",
    apply_time: 1654528504000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 8,
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    duration: "7",
    email: "gkfhj@gmail.com",
    fee: 4500,
    has_loan_app: true,
    interest: 700,
    interestRate: 1,
    loan_status: 3,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 2500,
    paymentAmount: "10,700.00",
    principal: "10,000",
    reApplyFace: false,
    risk: 1000,
    secAppTime: null,
    service: 1000,
  },
  {
    amount2Account: "5,500.00",
    app_time: "06/06/2022",
    application_id: "5020220620000006048",
    apply_time: 1654527476000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 8,
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    duration: "7",
    email: "gkfhj@gmail.com",
    fee: 4500,
    has_loan_app: true,
    interest: 700,
    interestRate: 1,
    loan_status: 2,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 2500,
    paymentAmount: "10,700.00",
    principal: "10,000",
    reApplyFace: false,
    risk: 1000,
    secAppTime: null,
    service: 1000,
  },
  {
    amount2Account: "5,500.00",
    app_time: "06/06/2022",
    application_id: "5020220620000006045",
    apply_time: 1654525599000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 3,
    borrow_time: "2022-06-20",
    borrow_time_kim: "2022-06-20 21:35:46",
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    deposit_time: "25/06/2022",
    duration: "7",
    email: "gkfhj@gmail.com",
    fale_fee: "0.00",
    fee: 4500,
    has_loan_app: true,
    interest: 70,
    interestRate: 0.1,
    loan_status: 6,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 2500,
    pay_time: "20/06/2022",
    paymentAmount: "10,070.00",
    penalty: "1,600.00",
    penalty_days: 8,
    principal: "10,000",
    reApplyFace: false,
    reach_amount: "12,500.00",
    reach_time: 1655658000000,
    real_reach_time: "2022-06-20 00:00:00",
    remainAmount: "0.00",
    repaymentAmount: "10.00",
    repayment_day: "0",
    risk: 1000,
    rollover_fee: "4,500",
    secAppTime: null,
    service: 1000,
  },
  {
    amount2Account: "5,500.00",
    app_time: "06/06/2022",
    application_id: "5020220620000006036",
    apply_time: 1654511836000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 3,
    borrow_time: "2022-06-20",
    borrow_time_kim: "2022-06-20 17:53:41",
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    deposit_time: "24/06/2022",
    duration: "7",
    email: "gkfhj@gmail.com",
    fale_fee: "0.00",
    fee: 4500,
    has_loan_app: true,
    interest: 70,
    interestRate: 0.1,
    loan_status: 6,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 2500,
    pay_time: "20/06/2022",
    paymentAmount: "10,070.00",
    penalty: "598.80",
    penalty_days: 3,
    principal: "10,000",
    reApplyFace: false,
    reach_amount: "10,868.80",
    reach_time: 1655709979000,
    real_reach_time: "2022-06-20 14:26:19",
    remainAmount: "0.00",
    repaymentAmount: "10,368.80",
    repayment_day: "0",
    risk: 1000,
    rollover_fee: "4,500",
    secAppTime: null,
    service: 1000,
  },
  {
    amount2Account: "5,500.00",
    app_time: "06/06/2022",
    application_id: "5020220620000006034",
    apply_time: 1654511468000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 3,
    borrow_time: "2022-06-20",
    borrow_time_kim: "2022-06-20 17:32:59",
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    deposit_time: "25/06/2022",
    duration: "7",
    email: "gkfhj@gmail.com",
    fale_fee: "0.00",
    fee: 4500,
    has_loan_app: true,
    interest: 70,
    interestRate: 0.1,
    loan_status: 6,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 2500,
    pay_time: "20/06/2022",
    paymentAmount: "10,070.00",
    penalty: "0.00",
    penalty_days: 0,
    principal: "10,000",
    reApplyFace: false,
    reach_amount: "10,010.00",
    reach_time: 1655658000000,
    real_reach_time: "2022-06-20 00:00:00",
    remainAmount: "0.00",
    repaymentAmount: "10,010.00",
    repayment_day: "0",
    risk: 1000,
    rollover_fee: "4,500",
    secAppTime: null,
    service: 1000,
  },
  {
    amount2Account: "5,500.00",
    app_time: "06/06/2022",
    application_id: "5020220620000006032",
    apply_time: 1654509693000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 3,
    borrow_time: "2022-06-20",
    borrow_time_kim: "2022-06-20 17:22:59",
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    deposit_time: "25/06/2022",
    duration: "7",
    email: "gkfhj@gmail.com",
    fale_fee: "0.00",
    fee: 4500,
    has_loan_app: true,
    interest: 70,
    interestRate: 0.1,
    loan_status: 6,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 2500,
    pay_time: "20/06/2022",
    paymentAmount: "10,070.00",
    penalty: "0.00",
    penalty_days: 0,
    principal: "10,000",
    reApplyFace: false,
    reach_amount: "10,000.00",
    reach_time: 1655658000000,
    real_reach_time: "2022-06-20 00:00:00",
    remainAmount: "0.00",
    repaymentAmount: "7,000.00",
    repayment_day: "0",
    risk: 1000,
    rollover_fee: "4,500",
    secAppTime: null,
    service: 1000,
  },
  {
    amount2Account: "5,500.00",
    app_time: "06/06/2022",
    application_id: "5020220620000006030",
    apply_time: 1654507495000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 3,
    borrow_time: "2022-06-20",
    borrow_time_kim: "2022-06-20 16:49:14",
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    deposit_time: "25/06/2022",
    duration: "7",
    email: "gkfhj@gmail.com",
    fale_fee: "0.00",
    fee: 4500,
    has_loan_app: true,
    interest: 70,
    interestRate: 0.1,
    loan_status: 6,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 2500,
    pay_time: "20/06/2022",
    paymentAmount: "10,070.00",
    penalty: "0.00",
    penalty_days: 0,
    principal: "10,000",
    reApplyFace: false,
    reach_amount: "10,020.00",
    reach_time: 1655658000000,
    real_reach_time: "2022-06-20 00:00:00",
    remainAmount: "0.00",
    repaymentAmount: "7,020.00",
    repayment_day: "0",
    risk: 1000,
    rollover_fee: "4,500",
    secAppTime: null,
    service: 1000,
  },
  {
    amount2Account: "3,500.00",
    app_time: "03/06/2022",
    application_id: "5020220616000006027",
    apply_time: 1654198809000,
    approval_time: "",
    bankName: "Ecobank Nigeria",
    bank_code: "050",
    bid_status: 3,
    borrow_time: "2022-06-18",
    borrow_time_kim: "2022-06-18 00:31:02",
    card_holder: "Helen Olaofe",
    card_no: "4141036963",
    chargeType: 10,
    deposit_time: "16/06/2022",
    duration: "1",
    email: "gkfhj@gmail.com",
    fale_fee: "0.00",
    fee: 1500,
    has_loan_app: true,
    interest: 2.5,
    interestRate: 0.05,
    loan_status: 8,
    mobile: "08021021021",
    no_ktp: "221*****424",
    pay: 500,
    pay_time: "20/06/2022",
    paymentAmount: "5,002.50",
    penalty: "100.00",
    penalty_days: 3,
    principal: "5,000",
    reApplyFace: false,
    reach_amount: "5,152.50",
    reach_time: 1655658000000,
    real_reach_time: "2022-06-20 00:00:00",
    remainAmount: "0.00",
    repaymentAmount: "2,952.50",
    repayment_day: "0",
    risk: 500,
    rollover_fee: "1,500",
    secAppTime: null,
    service: 500,
  },
];

// 性别
export const genderOptions = [
  {
    text: "Nam",
    value: 1,
  },
  {
    text: "Nữ",
    value: 0,
  },
];
/**
 * 审核中       Đang xem xét
 * 贷款已通过   khoản vay đã thông qua
 * 贷款已关闭   khoản vay đã đóng
 * 贷款已拒绝   khoản vay bị từ chối
 * 放款中       đã giải ngân
 * 已逾期       quá hạn
 * 待还款       sắp hoàn trả
 * 贷款已结清   khoản vay đã được giải quyết
 */
// 教育程度
export const educationOptions = [
  {
    text: "đọc",
    value: 0,
  },
  {
    text: "Trung học phổ thông",
    value: 1,
  },
  {
    text: "Trường trung học Kỹ thuật",
    value: 2,
  },
  {
    text: "Trường cao đẳng",
    value: 3,
  },
  {
    text: "Đại học(cử nhân)",
    value: 4,
  },
  {
    text: "bậc thầy",
    value: 5,
  },
  {
    text: "Bằng tiến sĩ",
    value: 6,
  },
  {
    text: "trường tiểu học",
    value: 8,
  },
  {
    text: "trường trung học cơ sở",
    value: 9,
  },
];

// 婚姻状况
export const marriageOptions = [
  {
    text: "Đã cưới",
    value: 1,
  },
  {
    text: "Ly hôn",
    value: 2,
  },
  {
    text: "chưa kết hôn",
    value: 3,
  },
  {
    text: "khác",
    value: 4,
  },
];
// 住房类型
export const houseTypeOptions = [
  {
    text: "Nhà thế chấp",
    value: 1,
  },
  {
    text: "Nhà mua đã thanh toán đầy đủ không trả góp",
    value: 2,
  },
  {
    text: "Nhà tự xây",
    value: 3,
  },
  {
    text: "Nhà tái định cư",
    value: 4,
  },
  {
    text: "Khác",
    value: 5,
  },
];

// 居住时长
export const liveTimeOptions = [
  {
    text: "Chưa đầy 1 tháng",
    value: 1,
  },
  {
    text: "1-3 tháng",
    value: 2,
  },
  {
    text: "3-6 tháng",
    value: 3,
  },
  {
    text: "6-12 tháng",
    value: 4,
  },
  {
    text: "1-2 năm",
    value: 5,
  },
  {
    text: "2-5 năm",
    value: 6,
  },
  {
    text: "Hơn 5 năm",
    value: 7,
  },
];

// 工作类型
/**
 * 1:经销商 2:医务人员 3:教师，教育工作者 4:家庭主妇 5:建筑师 6:经纪人7:艺术工作者 8:主管 9:海上运输人员
 * 10:航空运输人员 11:陆地运输人员 12:渔夫 13:会计/财务 14:律师 15:工程师
 * 16:设计师 17:保安 18:政府官员 19:政府雇员 20:医生 21:军人 22:外包人员 23:厨师 24:研究员
 * 25:学生 26:信息技术人员 27:饲养员 28:服务业 29:农民 30:顾问 31:工匠 32:企业家
 * 33:工人 34:普通管理员 35:市场人员 36:退休工 37:警察 38:客服 39:调酒师 40:行政 41:飞行员
 * 42:空姐 43:公证人 44:指挥官 45:司机 46:机械工程师99:其它
 */
export const jobTypeOptions = [
  {
    text: "Đại lý",
    value: "1",
  },
  {
    text: "Nhân viên y tế",
    value: "2",
  },
  {
    text: "Giáo viên, nhân viên giáo dục",
    value: "3",
  },
  {
    text: "bà nội trợ",
    value: "4",
  },
  {
    text: "Kiến trúc sư",
    value: "5",
  },
  {
    text: "Nhà môi giới",
    value: "6",
  },
  {
    text: "Nghệ sĩ",
    value: "7",
  },
  {
    text: "Người giám sát",
    value: "8",
  },
  {
    text: "Nhân viên vận tải hàng hải",
    value: "9",
  },
  {
    text: "Nhân viên vận tải hàng không",
    value: "10",
  },
  {
    text: "Nhân viên vận tải đường bộ",
    value: "11",
  },
  {
    text: "Ngư dân",
    value: "12",
  },
  {
    text: "Kế toán/Tài chính",
    value: "13",
  },
  {
    text: "Luật sư",
    value: "14",
  },
  {
    text: "Kỹ sư",
    value: "15",
  },
  {
    text: "Nhà thiết kế",
    value: "16",
  },
  {
    text: "Bảo mật",
    value: "17",
  },
  {
    text: "Các quan chức chính phủ",
    value: "18",
  },
  {
    text: "Nhân viên chính phủ",
    value: "19",
  },
  {
    text: "Bác sĩ",
    value: "20",
  },
  {
    text: "Quân sự",
    value: "21",
  },
  {
    text: "Nhân viên gia công",
    value: "22",
  },
  {
    text: "Chef",
    value: "23",
  },
  {
    text: "Nhà nghiên cứu",
    value: "24",
  },
  {
    text: "Học sinh",
    value: "25",
  },
  {
    text: "Kỹ thuật viên thông tin",
    value: "26",
  },
  {
    text: "Breeder",
    value: "27",
  },
  {
    text: "ngành dịch vụ",
    value: "28",
  },
  {
    text: "Nông dân",
    value: "29",
  },
  {
    text: "Chuyên gia tư vấn",
    value: "30",
  },
  {
    text: "Craftsman",
    value: "31",
  },
  {
    text: "Doanh nhân",
    value: "32",
  },
  {
    text: "công nhân",
    value: "33",
  },
  {
    text: "Quản trị viên thông thường",
    value: "34",
  },
  {
    text: "Nhân viên thị trường",
    value: "35",
  },
  {
    text: "nghỉ hưu",
    value: "36",
  },
  {
    text: "Cảnh sát",
    value: "37",
  },
  {
    text: "Dịch vụ khách hàng",
    value: "38",
  },
  {
    text: "Thương gia thuyền",
    value: "39",
  },
  {
    text: "Quản trị",
    value: "40",
  },
  {
    text: "Phi công",
    value: "41",
  },
  {
    text: "tiếp viên",
    value: "42",
  },
  {
    text: "Công chứng",
    value: "43",
  },
  {
    text: "Chỉ huy",
    value: "44",
  },
  {
    text: "người lái xe",
    value: "45",
  },
  {
    text: "Kỹ sư cơ khí",
    value: "46",
  },
  {
    text: "Những người khác",
    value: "99",
  },
];

/**
 * 工作年限
 * 1:小于1个月 2:1-3个月 3:3-6个月 4:6-12个月 5:1-2年 6:2-5年 7:5年以上
 */
export const jobTimeOptions = [
  {
    text: "Chưa đầy 1 tháng",
    value: 1,
  },
  {
    text: "1-3 tháng",
    value: 2,
  },
  {
    text: "3-6 tháng",
    value: 3,
  },
  {
    text: "6-12 tháng",
    value: 4,
  },
  {
    text: "1-2 năm",
    value: 5,
  },
  {
    text: "2-5 năm",
    value: 6,
  },
  {
    text: "Hơn 5 năm",
    value: 7,
  },
];
/**
 * 月收入
 * 1：400万盾以下 2：400-600万盾 3：600-800万盾 4：800-1000万盾
 * 5：1000-1500万盾  6：1500-2000万盾 7：2000万盾以上
 **/
export const incomeLevelOptions = [
  {
    value: 1,
    text: "Ít hơn 4 triệu đồng",
  },
  {
    value: 2,
    text: "4-6 triệu đồng",
  },
  {
    value: 3,
    text: "6-8 triệu đồng",
  },
  {
    value: 4,
    text: "8-10 triệu đồng",
  },
  {
    value: 5,
    text: "10-15 triệu đồng",
  },
  {
    value: 6,
    text: "15-20 triệu đồng",
  },
  {
    value: 7,
    text: "Hơn 20 triệu đồng",
  },
];

/**
 * 子女数 1:0个 2:1个 3:2个 4:3个 5:4个 6:5个及以上
 */
export const childrenNumOptions = [
  {
    value: 0,
    text: "0 con",
  },
  {
    value: 1,
    text: "1 con",
  },
  {
    value: 2,
    text: "2 con",
  },
  {
    value: 3,
    text: "3 con",
  },
  {
    value: 4,
    text: "4 con",
  },
  {
    value: 5,
    text: "5 con trở lên con",
  },
];

/**
 * 亲属联系人 && 其他联系人
 * 1其他 2父亲 3兄弟姐妹 4同事 5同学 6亲戚 7朋友 8配偶 9子女 10母亲
 */
export const immediateFamilyTypeOptions = [
  {
    text: " Khác",
    value: "0",
  },
  {
    text: " Cha mẹ",
    value: "1",
  },
  {
    text: " Anh chị em",
    value: "2",
  },
  {
    text: " đồng nghiệp",
    value: "3",
  },
  {
    text: " bạn cùng lớp",
    value: "4",
  },
  {
    text: " Người thân",
    value: "5",
  },
  {
    text: " bạn bè",
    value: "6",
  },
  {
    text: " Người phối ngẫu",
    value: "7",
  },
  {
    text: " Trẻ em",
    value: "8",
  },
];

export const otherContactsTypeOptions = [
  {
    text: " Khác",
    value: "0",
  },
  {
    text: " Cha mẹ",
    value: "1",
  },
  {
    text: " Anh chị em",
    value: "2",
  },
  {
    text: " đồng nghiệp",
    value: "3",
  },
  {
    text: " bạn cùng lớp",
    value: "4",
  },
  {
    text: " Người thân",
    value: "5",
  },
  {
    text: " bạn bè",
    value: "6",
  },
  {
    text: " Người phối ngẫu",
    value: "7",
  },
  {
    text: " Trẻ em",
    value: "8",
  },
];

export const cityOptions = [
  {
    value: 1,
    text: "Hồ Chí Minh",
  },
  {
    value: 2,
    text: "An Giang",
  },
  {
    value: 3,
    text: "Bạc Liêu",
  },
  {
    value: 4,
    text: "Bà Rịa Vũng Tàu",
  },
  {
    value: 5,
    text: "Bắc Giang",
  },
  {
    value: 6,
    text: "Bắc Kạn",
  },
  {
    value: 7,
    text: "Bắc Ninh",
  },
  {
    value: 8,
    text: "Bến Tre",
  },
  {
    value: 9,
    text: "Bình Dương",
  },
  {
    value: 10,
    text: "Bình Định",
  },
  {
    value: 11,
    text: "Bình Phước",
  },
  {
    value: 12,
    text: "Bình Thuận",
  },
  {
    value: 13,
    text: "Cà Mau",
  },
  {
    value: 14,
    text: "Cao Bằng",
  },
  {
    value: 15,
    text: "Cần Thơ",
  },
  {
    value: 16,
    text: "Đà Nẵng",
  },
  {
    value: 17,
    text: "Đăk Lăk",
  },
  {
    value: 18,
    text: "Đăk Nông",
  },
  {
    value: 19,
    text: "Điện Biên",
  },
  {
    value: 20,
    text: "Đồng Nai",
  },
  {
    value: 21,
    text: "Đồng Tháp",
  },
  {
    value: 22,
    text: "Gia Lai",
  },
  {
    value: 23,
    text: "Hà Giang",
  },
  {
    value: 24,
    text: "Hải Dương",
  },
  {
    value: 25,
    text: "Hải Phòng",
  },
  {
    value: 26,
    text: "Hà Nam",
  },
  {
    value: 27,
    text: "Hà Nội",
  },
  {
    value: 28,
    text: "Hà Tĩnh",
  },
  {
    value: 29,
    text: "Hậu Giang",
  },
  {
    value: 30,
    text: "Hòa Bình",
  },
  {
    value: 31,
    text: "Hưng Yên",
  },
  {
    value: 32,
    text: "Khánh Hòa",
  },
  {
    value: 33,
    text: "Kiên Giang",
  },
  {
    value: 34,
    text: "Kon Tum",
  },
  {
    value: 35,
    text: "Lai Châu",
  },
  {
    value: 36,
    text: "Lạng Sơn",
  },
  {
    value: 37,
    text: "Lào Cai",
  },
  {
    value: 38,
    text: "Lâm Đồng",
  },
  {
    value: 39,
    text: "Long An",
  },
  {
    value: 40,
    text: "Nam Định",
  },
  {
    value: 41,
    text: "Nghệ An",
  },
  {
    value: 42,
    text: "Ninh Bình",
  },
  {
    value: 43,
    text: "Ninh Thuận",
  },
  {
    value: 44,
    text: "Phú Thọ",
  },
  {
    value: 45,
    text: "Phú Yên",
  },
  {
    value: 46,
    text: "Quảng Bình",
  },
  {
    value: 47,
    text: "Quảng Nam",
  },
  {
    value: 48,
    text: "Quảng Ngãi",
  },
  {
    value: 49,
    text: "Quảng Ninh",
  },
  {
    value: 50,
    text: "Quảng Trị",
  },
  {
    value: 51,
    text: "Sóc Trăng",
  },
  {
    value: 52,
    text: "Sơn La",
  },
  {
    value: 53,
    text: "Tây Ninh",
  },
  {
    value: 54,
    text: "Thái Bình",
  },
  {
    value: 55,
    text: "Thái Nguyên",
  },
  {
    value: 56,
    text: "Thanh Hóa",
  },
  {
    value: 57,
    text: "Thừa Thiên Huế",
  },
  {
    value: 58,
    text: "Tiền Giang",
  },
  {
    value: 59,
    text: "Trà Vinh",
  },
  {
    value: 60,
    text: "Tuyên Quang",
  },
  {
    value: 61,
    text: "Vĩnh Long",
  },
  {
    value: 62,
    text: "Vĩnh Phúc",
  },
  {
    value: 63,
    text: "Yên Bái",
  },
];
